// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"2d063992","196":"0a87574a"}[chunkId] + ".chunk.js";
};